import { AccountType } from '../../graphql/search'

export const accountTypeOptions: { label: string; value: AccountType }[] = [
  {
    label: 'Checking',
    value: 'CHECKING',
  },
  {
    label: 'Savings',
    value: 'SAVINGS',
  },
]
